import React, { useEffect, useState } from 'react';
import { connectToWifi, getWifiList } from 'api/api_service';
import WiFiList from './wifi_list';
import strings from '../../strings/strings.json'
import { Modal, Box, CircularProgress } from '@mui/material';
import ConnectWifi from './connect_wifi';
import { useDispatch } from "react-redux";
import { showSnackbar } from "../../state/actions";
import { IWiFi } from 'types';
import { Spin } from 'antd';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: '0 1px 60px 0 rgba(155, 181, 190, 0.2)',
  borderRadius: '14px',
  p: 4,
};
export default function Wifi() {


  const [list, setList] = useState([])
  const [opeModal, setOpenModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [connectLoading, setConnectLoading] = useState(false)
  const [rowClickedData, setRowClickedData] = useState<object>()
  const dispatch = useDispatch();

  useEffect(() => {
    getList()
  }, [])

  const getList = () => {
    getWifiList()
      .then(res => {
        if (res.status === 200 && res.data.data) {
          setIsLoading(false)
          setList(res.data.data)
        } else {
          setIsLoading(false)
        }
      })
      .catch(err => {
        setIsLoading(false)
        if (err.response.data.error_code === 96) {
          dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.demo_error }));
        }  else {
           dispatch(showSnackbar({ "open": true, severity: "error", msg: strings.public_error }));
       }              	
   })
  }

  const wifiRowClicked = (data: any) => {
    if (!data.encrypted) {
      confrimHandler(data.ssid, '')
    } else {
      setRowClickedData(data)
      setOpenModal(true)
    }
  }

  const handleCloseModal = () => setOpenModal(false);
  const scanAgainClickHandler = () => {
    setIsLoading(true)
    getList()
  }

  const confrimHandler = (ssid: string, password: string) => {
    setConnectLoading(true)
    let obj: any = {}
    obj["ssid"] = ssid
    if (password)
      obj["password"] = password

    connectToWifi(obj)
      .then(res => {
        setConnectLoading(false)
        setOpenModal(false)
        if (res.status === 200 && res.data.success) {
          dispatch(showSnackbar({ "open": true, 'severity': 'success', 'msg': `${strings.public_connectSuccessful}` }));
        } else {
          dispatch(showSnackbar({ "open": true, 'severity': 'error', 'msg': `${strings.public_error}` }));
        }
      })
  }

  const listMapper = (data: any, index: number) => {
    return (
      <React.Fragment key={index}>
        <WiFiList
          data={data}
          wifiRowClicked={(data) => wifiRowClicked(data)}
        />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <div className={`border border-gray-100 rounded-lg px-5 mt-10 h-60 cursor-pointer ${(list.length > 4) ? 'overflow-y-scroll' : ''}`}>
        {
          connectLoading ?
            <div className='flex justify-center items-center mt-28'>
              <Spin size='large' />
            </div>
            :
            <React.Fragment>
              {(!isLoading && list.length !== 0) ?
                list.map(listMapper)
                :
                <div className='flex justify-center mt-20 secondry_text_color'>{strings.public_notFound}</div>
              }
            </React.Fragment>
        }
      </div>
      {
        !connectLoading &&
        <div className='mt-5'>
          <button
            className='flex text-white rounded-full px-8 py-3 primary_bg_color mt-1'
            onClick={() => !isLoading && scanAgainClickHandler()}>
            {isLoading ? <CircularProgress color="inherit" size={20} /> : <span>{strings.public_scanAgain}</span>}
          </button>
        </div>
      }
      <Modal
        open={opeModal}
        onClose={handleCloseModal}>
        <Box sx={style}>
          <ConnectWifi
            data={rowClickedData}
            onCancelModal={handleCloseModal}
            confirmConnectToWifi={(ssid, password) => confrimHandler(ssid, password)}
          />
        </Box>
      </Modal>
    </React.Fragment>
  )
}
